import { IAppContextState } from 'src/reducers/AppContext';

export class UrlFactory {
    static RootApi = `/v1.0/`;

    static ForClient = (appContext: IAppContextState) => {
        return `/v1.0/clients/${appContext.clientNumber}`;
    };

    static ForProject = (appContext: IAppContextState) => {
        return `${UrlFactory.ForClient(appContext)}/projects/${appContext.projectNumber}`;
    };

    static ForField = (appContext: IAppContextState) => {
        return `${UrlFactory.ForProject(appContext)}/fields/${appContext.fieldNumber}`;
    };

    static ForTract = (appContext: IAppContextState) => {
        return `${UrlFactory.ForField(appContext)}/tracts/${appContext.tractNumber}`;
    };

    static ForHorizon = (appContext: IAppContextState) => {
        return `${UrlFactory.ForTract(appContext)}/horizons/${appContext.horizonNumber}`;
    };

    static ForOwnership = (appContext: IAppContextState) => {
        return `${UrlFactory.ForHorizon(appContext)}/ownership/${appContext.ownershipId}`;
    };

    static ForLeasehold = (appContext: IAppContextState) => {
        return `${UrlFactory.ForOwnership(appContext)}/leasehold/${appContext.leaseholdId}`;
    };
}



// WEBPACK FOOTER //
// ./src/api/urlHelper.ts